'use client';
import React, { FC, useRef } from 'react';

import PortableBlock from '@/src/components/ui/portableText/PortableText';
import styles from './PortableTextSection.module.scss';
import TableContent from '@/src/components/ui/tableContent/TableContent';
import { Block } from '@/src/lib/types/blockInterface';

type TContent = {
  content: Block[];
};

const PortableTextSection: FC<TContent> = ({ content }) => {
  const activeAnchor = useRef<string | null>(null);
  const handleAnchorClick = (anchorKey: string) => {
    activeAnchor.current = anchorKey;
  };

  const headings = content.filter(
    (item) => item.style === 'h4' || item.style === 'h3' || item.style === 'h2'
  );

  return (
    <div className={styles.wrapper}>
      {headings && headings.length > 0 && (
        <TableContent
          headings={headings}
          activeAnchor={activeAnchor.current}
          handleAnchorClick={handleAnchorClick}
        />
      )}
      <div className={styles.portable__component}>
        <PortableBlock value={content} />
      </div>
    </div>
  );
};

export default PortableTextSection;
